import React from 'react';
import PropTypes from 'prop-types';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import { useLocalState } from '@adsk/alloy-react-helpers';
const SideNavigationContext = getOrCreateGlobalContext(CONTEXT_NAMES.SideNavigationContext);
export const useSideNavigation = () => useContextWithValidation(SideNavigationContext, {
  hook: 'useSideNavigation',
  provider: 'SideNavigationProvider'
});
const STORAGE_KEY = 'ACC_SIDE_NAVIGATION_LOCAL_STORAGE_KEY';
export const SideNavigationProvider = _ref => {
  let {
    children
  } = _ref;
  const [collapsed, setCollapsed] = useLocalState(STORAGE_KEY, false);
  return /*#__PURE__*/React.createElement(SideNavigationContext.Provider, {
    value: {
      collapsed,
      setCollapsed
    }
  }, children);
};
SideNavigationProvider.displayName = 'SideNavigationProvider';
SideNavigationProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=SideNavigationContext.js.map